var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"uppercase text-white font-black tracking-wide text-center p-1 rounded",class:[`bg-${_vm.colors[_vm.status]}`],staticStyle:{"font-size":"0.6rem"}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.labels[_vm.status]))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }